// src/api_scripts/createAddressBookEntry.js
import { createApiClient } from "../apiClient";

const createAddressBookEntry = async (addressBookID, orgId, entrydata, accessToken, setProgress) => {
  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Address Book Entry: "${entrydata.name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // Construct the relative URI for the POST request
  // Ensure the addressBookID and orgId are correctly integrated into the URI path
  const relativeUri = `organization/${orgId}/address-book/${addressBookID}/entry`;

  // Construct the request body for creating an address book entry.
  const requestBody = {
    name: entrydata.name,
    number: entrydata.number
  };

  try {
    // Create the API client instance with the access token
    const apiClient = createApiClient(accessToken);

    // Perform the POST request using the client instance's post method
    // Axios responses wrap the actual data in a `data` property
    const response = await apiClient.post(relativeUri, requestBody);
    const result = response.data; // Access the actual data from the Axios response

    console.log("Create Address Book Entry API Response Data:", result);

    if (result && result.id) {
      setProgress((prev) => [
        ...prev,
        { type: 'success', message: `Successfully created Address Book Entry "${entrydata.name}" with ID: ${result.id}`, timestamp: new Date().toLocaleTimeString() }
      ]);
      return result.id; // Return the ID of the newly created address book entry
    } else {
      setProgress((prev) => [
        ...prev,
        { type: 'error', message: `Failed to create Address Book Entry "${entrydata.name}". No ID returned or unexpected response.`, timestamp: new Date().toLocaleTimeString() }
      ]);
      return null;
    }

  } catch (error) {
    console.error(`Error creating Address Book Entry "${entrydata.name}":`, error);

    let errorMessage = `Error creating Address Book Entry "${entrydata.name}": ${error.message || String(error)}`;

    // Check for specific API error response structure to add more detail
    if (error.response && error.response.data && error.response.data.error && error.response.data.error.reason) {
      errorMessage += ` (Reason: ${error.response.data.error.reason})`;
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error; // Re-throw the error for centralized handling in SpreadsheetProcessor.js
  }
};

export default createAddressBookEntry;
